import React, { useState, useEffect } from "react";
import FreeformJigsawSvg from "./jigsaw/FreeformJigsawSvg";

/**
 * @typedef {"square"|"interlock"} PuzzleType
 */

function themeVariantFromPieceType(pieceType) {
  if (pieceType === "square") return "square";
  if (pieceType === "irregular") return "irregular";
  return "classic";
}

/**
 * Dynamic jigsaw: square grid or interlocking pieces.
 * Drag pieces; release near a slot to snap and swap with any occupant.
 *
 * @param {PuzzleType} puzzleType
 */
export default function JigsawPuzzle({
  imageUrl,
  rows,
  cols,
  screenWidth,
  pieceType = "classic",
  /** @type {PuzzleType} */
  puzzleType = "interlock",
  onComplete,
  onPuzzleSolved,
  onCorrectPieceCountChange,
}) {
  const [box, setBox] = useState({ w: null, h: null });
  void screenWidth;

  const variant = themeVariantFromPieceType(pieceType);

  useEffect(() => {
    if (!imageUrl || rows < 1 || cols < 1) return;
    const img = new Image();
    img.onload = () => {
      let w = img.naturalWidth;
      let h = img.naturalHeight;
      const maxH = Math.min(window.innerHeight * 0.72, 820);
      if (h > maxH) {
        w = (w * maxH) / h;
        h = maxH;
      }
      setBox({ w, h });
    };
    img.src = imageUrl;
  }, [imageUrl, rows, cols]);

  if (!imageUrl) {
    return (
      <div className="jigsaw-puzzle-loading">
        <div className="quiz-loader" />
      </div>
    );
  }

  if (!box.w || !box.h) {
    return (
      <div className="jigsaw-puzzle-loading">
        <div className="quiz-loader" />
      </div>
    );
  }

  return (
    <div className="freeform-jigsaw-host">
      <FreeformJigsawSvg
        imageUrl={imageUrl}
        rows={rows}
        cols={cols}
        puzzleType={puzzleType}
        variant={variant}
        boardW={box.w}
        boardH={box.h}
        onComplete={onComplete}
        onPuzzleSolved={onPuzzleSolved}
        onCorrectPieceCountChange={onCorrectPieceCountChange}
      />
    </div>
  );
}
